import { render, staticRenderFns } from "./AccessibilityDeclaration.vue?vue&type=template&id=3289ce26&scoped=true&"
import script from "./AccessibilityDeclaration.vue?vue&type=script&lang=js&"
export * from "./AccessibilityDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityDeclaration.vue?vue&type=style&index=0&id=3289ce26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3289ce26",
  null
  
)

export default component.exports